import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StringLengthLimiter } from 'src/app/common/helpers/string-length-limiter';
import { NotifierEvents, TreeLevel } from 'src/app/common/enums/enums';
import { RootMemberMapper } from 'src/app/common/mappers/RootMemberMapper';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';
import { StringLimiter } from 'src/app/common/helpers/string-limiter';
type Phase = 'idle' | 'highlight' | 'travelToRoot' | 'release';
@Component({
    selector: 'g[app-level6labels]',
    templateUrl: './level6labels.component.html',
    styleUrls: ['./level6labels.component.scss'],
    standalone: false
})
export class Level6labelsComponent implements OnInit {
  limitLength: number = 26;

  @Input() label: any;
  @Input() i: number;
  @Input() rootMember: any;
  @Output() openInputFormBoxWithData = new EventEmitter();
  splitDisplayName : any;

  @Input() selectedNodeId: any;
  @Input() allRelationsLoaded = false;  
  @Output() changeRootPerson = new EventEmitter<any>();
  @Input() isZoomedNode: boolean = false;
  @Input() animationPhase: Phase = 'idle';

  constructor(public stringLimit: StringLengthLimiter,
    private notifierService: NotifierV2Service,
    private rootMemberMapper: RootMemberMapper,
    public stringLimiter: StringLimiter) {
  }

  breakText = function (text: String, line: number) {
    return this.stringLimit.breakText(text, line, this.limitLength);
  }

  ngOnInit(): void {
    this.setStringLimit();
  }

  readonly genderMap = {
    M: 'male',
    F: 'female',
    U: 'unknown'
  };

  shouldHideLeaves(label: any): boolean {
    const focusId = this.selectedNodeId; 
    if (focusId == null) return false;

    // Hide leaves for the whole "group"
    const labelGroup = Math.floor(Number(label.displayIndex));
    const focusGroup = Math.floor(Number(focusId));

    return labelGroup === focusGroup;
  }

  expandWheel(content) {
    content.expanded = !content.expanded;
  }

  addParent(index, label) {
    this.openInputFormBoxWithData.emit({ index, label });
  }

  setStringLimit(){
    this.splitDisplayName =  this.stringLimiter.splitString(this.label.displayName, TreeLevel.Four)
  }

}
